import type { FC } from 'react';
import { TooltipContent } from '@mwl/ui';
import type { TooltipContentPropsV2 } from './TooltipContentV2.types';
import styles from './TooltipContentV2.module.scss';
export const TooltipContentV2: FC<TooltipContentPropsV2> = ({
  children,
  className,
  classes,
  variant = 'black',
  ...props
}) => {
  return <TooltipContent {...props} className={cn(styles.content, className, styles[`${variant}Variant`])} classes={{
    ...classes,
    arrow: cn(styles.arrow, classes?.arrow, styles[`${variant}ArrowVariant`])
  }} data-sentry-element="TooltipContent" data-sentry-component="TooltipContentV2" data-sentry-source-file="TooltipContentV2.tsx">
      {children}
    </TooltipContent>;
};